module.exports = __webpack_public_path__ + "static/img/header4.659afda9.jpg";